export default "__VITE_ASSET__DuAzXFyi__"